const nameAction = (state = "", action) => {
    switch(action.type) {
        case 'nameAction':
            return action.payload;
        default:
            return state;
    }
}

export default nameAction;